import { ChangeDetectionStrategy, Component, NgZone, OnDestroy, OnInit, ViewEncapsulation, inject, signal } from '@angular/core';
import { SessionService } from 'account-hybrid/core/authentication';
import { SpacesService } from 'account-hybrid/common/components/spaces';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import PartnersActions from 'v2/app/features/cooperative/partners/actions/index';
import { CooperativeNgReduxFacade } from './store/cooperative-ngredux.facade';

/**
 * Cooperative "Partners" section: subscribes to the cooperative ngRedux store
 * (via the NgRx facade), dispatches the get-partners thunk, and renders the
 * partner organizations as background-image panels.
 */
@Component({
    selector: 'ft-cooperative-partners-ng',
    imports: [AccountSharedModule],
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./cooperative-partners.component.scss'],
    templateUrl: './cooperative-partners.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CooperativePartnersComponent implements OnInit, OnDestroy {
    protected readonly partners = signal<any[]>([]);

    private readonly sessionService = inject(SessionService);
    private readonly spacesService = inject(SpacesService);
    private readonly zone = inject(NgZone);
    private readonly advStore = inject(CooperativeNgReduxFacade);
    private $ngRedux: any;
    private unsubscribe?: () => void;

    ngOnInit(): void {
        // WS2 strangle: cooperative state now in the native NgRx feature (facade).
        this.$ngRedux = this.advStore;
        const company = this.sessionService.getCompany(this.spacesService.getCompanyUuid());
        if (!company) return;

        const sync = () => {
            const partnersState = this.$ngRedux.getState()?.views?.cooperative?.partners;
            this.zone.run(() => { this.partners.set((partnersState && partnersState.partners) || []); });
        };
        this.unsubscribe = this.$ngRedux.subscribe(sync);
        sync();
        this.$ngRedux.dispatch(PartnersActions.getPartners(company.UUID));
    }

    ngOnDestroy(): void {
        this.unsubscribe?.();
    }
}
